<app-modal-loading [show]="modal_loading"></app-modal-loading>

<div class="modal fade show modal-background" style="display:block" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content relax-gradiente text-white">
      <div class="modal-header">
        <h2 class="h3" id="staticBackdropLabel">Cambiar Contraseña de {{name}}</h2>
        <button type="button" class="btn btn-light  btn-sm" (click)="eventos.Closing()" >
          <i class="far fa-window-close"></i>
        </button>   
      </div>
      <div class="modal-body">
        <form [formGroup]="form">
          <div class="form-group">
            <label for="exampleInputPassword1">Password</label>
            <input type="password" formco class="form-control" id="exampleInputPassword1" formControlName="pass">
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary" (click)="crear()" [disabled]="!form.valid">Guardar</button>

      </div>
    </div>
  </div>
</div>
